var styles = {
  "style-1": "inline-flex items-center justify-center px-14 py-4 border border-blue-700 font-cta-label text-cta-label-mobile md:text-cta-label font-medium rounded-full text-black bg-white hover:text-white hover:bg-blue-700",
  "style-2": "inline-flex items-center justify-center px-14 py-4 border border-transparent font-cta-label text-cta-label-mobile md:text-cta-label font-medium rounded-full text-white bg-blue-500 hover:bg-blue-400",
  "style-3": "inline-flex items-center justify-center px-14 py-4 border border-transparent font-cta-label text-button md:text-button-md lg:text-button-lg rounded-full text-white bg-blue-500 hover:bg-blue-400",
  "style-4": "inline-flex items-center justify-center px-14 py-4 border border-transparent font-primary text-body-1 md:text-body-1-md 2xl:text-body-1-lg rounded-full text-white bg-blue-500 hover:bg-blue-400",
  "small-style-1": "inline-flex items-center justify-center px-8 py-2 border border-blue-700 font-cta-label text-cta-label-mobile md:text-cta-label font-medium rounded-full text-black bg-white hover:text-white hover:bg-blue-700",
  "small-style-2": "inline-flex items-center justify-center px-8 py-2 border border-transparent font-primary text-body-1-md rounded-full text-white bg-blue-500 hover:bg-blue-400",
}
/* This example requires Tailwind CSS v2.0+ */
function Cta(props) {
  var currentStyle = styles[props.style];
  var classes = props.classes || [];
  var icon = props.icon || null;
  var id = props.id || "";

  currentStyle += " " + classes.join(" ");
  if (props.type === "submit") {
    return (
      <button
        id={id}
        type="submit"
        className={currentStyle}
      >{props.label}</button>
    )
  } else {
    return (
      <div className="inline-flex">
        <a
          id={id}
          href={props.href}
          className={currentStyle}
          dangerouslySetInnerHTML={{ __html: props.label }}
        />
      </div>
    )

  }
}

export default Cta;
